import { isNum } from '@/libs/validator'
export default {
  data () {
    return {
      errorMsg: true,
      remain: {}
    }
  },
  methods: {
    sendRemainTime (data) {
      this.remain = data
    },
    handleSendChange (value) {
      let data = value.target.value
      this.errorMsg = true
      if (isNum(data) && data > this.remain.remainTime) {
        this.errorMsg = false
      }
    }
  }
}
